import { useCallback, useEffect, useState, Fragment } from "react";
import { Grid, TextField, Button } from "@mui/material";
import { StyledStack, StyledMenuItem, StyledTitle } from "./Notification.style";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { StyledLink } from "../../components/shared/Link";
import { MdAdd } from "react-icons/md";
import TableCM from "components/shared/Table";
import DrawerCM from "components/shared/Drawer";
import GenarateHeadCell from "helper/generate-head-cell";
import LoadingCM from "components/shared/Loading";
import useHttp from "hooks/use-http";
import Toast from "helper/toast";
import { NotificationSchema } from "validations";
import {
  getUsersRequest,
  getNotificationFrameRequest,
  sendNotificationRequest,
} from "api/requests";
import ReactHookFormSelect from "components/shared/ReactHookFormSelect";
import PaginationCM from "components/shared/Pagination";
import useSelected from "hooks/use-selected";
import DeleteModal from "components/shared/Modal/Delete";
import { PAGINATION_LIMIT } from "constants";

const headCells = GenarateHeadCell("users");
let initialPage = 1;

export default function Notification() {
  const selectCTX = useSelected();
  const [frame, setFrame] = useState({ data: [], count: 0 });
  const [users, setUsers] = useState({ data: [], count: 0 });
  const { request, loading, setLoading } = useHttp();
  const [page, setPage] = useState(initialPage);
  const [showSendModal, setshowSendModall] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(NotificationSchema),
  });

  const handelShowModal = () => setshowSendModall((state) => !state);

  const handelTempChange = (e) => {
    if (e === "new") {
      setValue("text", "");
    } else {
      setValue("text", e);
    }
  };

  const onSubmitAll = async (values) => {
    values = {
      type: values["notif-type"],
      text: values.text,
    };

    const res = await request({
      url: sendNotificationRequest,
      values,
    });

    handelShowModal();

    if (res) {
      reset({
        text: "",
        "notif-template": "new",
        "notif-type": "message",
      });
      selectCTX.removeItems();
      Toast({ type: "success" });
    }
  };
  const onSubmit = async (values) => {
    values = {
      type: values["notif-type"],
      text: values.text,
      users: selectCTX.selectedItems,
    };

    const res = await request({
      url: sendNotificationRequest,
      values,
    });

    if (res) {
      reset({
        text: "",
        "notif-template": "new",
        "notif-type": "message",
      });
      selectCTX.removeItems();
      Toast({ type: "success" });
    }
  };

  const getFrame = useCallback(async () => {
    const res = await request({
      url: getNotificationFrameRequest,
      values: { skip: (page - 1) * 50, limit: 50 },
    });

    if (res) {
      let transformedData = res.data.map((items) => ({
        id: items.id,
        title: items.title,
        text: items.text,
        isMulty: true,
      }));

      setFrame({ data: transformedData, count: res.count });
    }
  }, [request]);

  const handelSearch = (e) => getUsers(e);

  /////////////get users/////////////
  const getUsers = useCallback(
    async (search) => {
      setLoading(true);
      const res = await request({
        url: getUsersRequest,
        values: {
          skip: search ? 0 : (page - 1) * PAGINATION_LIMIT,
          limit: search ? 100 : PAGINATION_LIMIT,
          search,
          type: "user",
        },
        isMulty: true,
      });
      await getFrame();

      if (res) {
        let transformedData = res.data.map((items) => ({
          id: items.id,
          full_name: items.full_name,
          phone_number: items.phone_number,
        }));

        setUsers({ data: transformedData, count: res.count });
        setLoading(false);
      }
    },
    [page, request]
  );

  useEffect(() => {
    getUsers();
  }, [page, getUsers]);

  useEffect(() => {
    selectCTX.removeItems();
    return () => {
      selectCTX.removeItems();
    };
  }, []);

  return (
    <DrawerCM title="ارسال پیام" onSearch={handelSearch}>
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <StyledStack>
            <StyledTitle>
              ارسال پیام
              <StyledLink to="/notification/add">
                <Button endIcon={<MdAdd />} variant="contained" mt={1}>
                  افزودن قالب
                </Button>
              </StyledLink>
            </StyledTitle>
            <Grid container>
              <Grid item md={6} xs={12} p={1.5}>
                <ReactHookFormSelect
                  id="notif-type"
                  label="نحوه ارسال"
                  control={control}
                  defaultValue="message"
                  title="نحوه ارسال"
                >
                  <StyledMenuItem value="message" selected>
                    پیام
                  </StyledMenuItem>
                  <StyledMenuItem value="toast">
                    نوتیفیکیشن (toast)
                  </StyledMenuItem>
                  <StyledMenuItem value="sms">پیامک (sms)</StyledMenuItem>
                </ReactHookFormSelect>
              </Grid>
              <Grid item md={6} xs={12} p={1.5}>
                <ReactHookFormSelect
                  id="notif-template"
                  label="انتخاب قالب"
                  control={control}
                  defaultValue="new"
                  title="انتخاب قالب"
                  onChange={handelTempChange}
                >
                  <StyledMenuItem value="new" selected>
                    متن جدید
                  </StyledMenuItem>
                  {frame.data.map((row, index) => (
                    <StyledMenuItem value={row.text} key={"option" + index}>
                      {row.title}
                    </StyledMenuItem>
                  ))}
                </ReactHookFormSelect>
              </Grid>
              <Grid item xs={12} pt={3} p={1.5}>
                <TextField
                  label="متن"
                  variant="outlined"
                  multiline
                  rows={6}
                  fullWidth
                  focused
                  inputProps={{ readOnly: false }}
                  id="text"
                  {...register("text")}
                  error={Boolean(errors.text)}
                  helperText={errors.text?.message}
                />
              </Grid>
            </Grid>
          </StyledStack>
          <Grid container>
            <Grid item xs={12} my={2}>
              <TableCM
                title="انتخاب کاربران"
                rows={users.data}
                headCells={headCells}
                isSelectable
                onSubmit={handleSubmit(onSubmit)}
                onDelete={() => selectCTX.removeItems()}
                onSubmitAll={() => {
                  if (getValues("text").trim() === "") {
                    window.scroll({ top: 0 });
                    return handleSubmit()();
                  }
                  handelShowModal();
                }}
                page={page}
              />
            </Grid>
            <PaginationCM
              handleChange={(e, val) => {
                initialPage = val;
                setPage(val);
              }}
              page={page}
              count={users.count}
            />
          </Grid>
          <DeleteModal
            show={showSendModal}
            onClose={handelShowModal}
            onDelete={handleSubmit(onSubmitAll)}
            title="آیا میخواهد این متن را برای همه ارسال کنید؟"
          />
        </Fragment>
      )}
    </DrawerCM>
  );
}
